import React from 'react';

import PropTypes from 'prop-types';

import ArticleContentCover from './ArticleContentCover/ArticleContentCover';
import ArticleMarkdown from './ArticleMarkdown/ArticleMarkdown';
import ArticleVideo from './ArticleVideo/ArticleVideo';
import ArticleLandscapeImage from './ArticleLandscapeImage/ArticleLandscapeImage';
import ArticlePortraitImage from './ArticlePortraitImage/ArticlePortraitImage';
import ArticleShare from './ArticleShare/ArticleShare';
import useLanguage from '../../../../hooks/useLanguage';

const ArticleContent = ({ contentData }) => {
 
  // const imageCover = getImage(data.cover);
  const langToggle = useLanguage;

  return (
    <>
      {contentData.map((item, index) => {
        if (item.cover) {
          return <ArticleContentCover imageCover={item.cover} key={index} />;
        } else {
          return null;
        }
      })}
      {/* <ArticleContentCover imageCover={imageCover} /> */}
      <section className="aricle-content__wrapper" data-scroll-section>
        {contentData.map((item, index) => {
          if (item.article_text_ua || item.article_text_ru) {
            return <ArticleMarkdown content={langToggle(item.article_text_ua, item.article_text_ru)} key={index} />;
          } else if (item.video) {
            return <ArticleVideo video={item.video} key={index} />;
          } else if (item.image) {
            return <ArticleLandscapeImage img={item.image} key={index} />;
          } else if (item.image) {
            return <ArticlePortraitImage img={item.image} key={index} />;
          } else {
            return null;
          }
        })}
      </section>
      <ArticleShare />
    </>
  );
};

ArticleContent.propTypes = {
  contentData: PropTypes.array,
};

export default ArticleContent;
